import cx from 'classnames';

export interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeClasses: Record<NonNullable<SpinnerProps['size']>, string> = {
  sm: 'h-4 w-4 border-2',
  md: 'h-6 w-6 border-2',
  lg: 'h-8 w-8 border-2',
};

/**
 * Canonical spinner primitive for @repo/ui.
 *
 * Color is driven by the `--spinner-color` CSS custom property so it adapts
 * to any token context (e.g. `--anl-accent` in analytics). Falls back to
 * Tailwind's cyan-500 when no token is set.
 */
export function Spinner({ size = 'md', className }: SpinnerProps) {
  return (
    <div
      role="status"
      aria-label="Loading"
      className={cx(
        'animate-spin rounded-full border-[var(--spinner-color,theme(colors.cyan.500))] border-t-transparent',
        sizeClasses[size],
        className,
      )}
    />
  );
}
